import React, { useEffect, useState } from "react";
import PageLayout from "../layouts/MainLayout";
import ConvictionsList from "../components/Regulatory/ConvictionsList";

const RecentCourtCharges = () => {
  return (
    <PageLayout
      home={false}
      pageHeader={
        <>
          Court Charges and/or Convictions
        </>
      }
    >
      <p>The HCRA can lay charges under the New Home Construction Licensing Act (NHCLA), the Ontario New Home Warranties Plan Act (ONHWPA) or the Provincial Offences Act (POA). The Charge column shows the specific offence (section) under which a defendant was charged and convicted.</p>
      <ConvictionsList />
    </PageLayout>
  )
}

export default RecentCourtCharges;
